import { render, staticRenderFns } from "./UserProfileContactPrefs.vue?vue&type=template&id=5f7675e1&scoped=true&"
import script from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
export * from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileContactPrefs.vue?vue&type=style&index=0&id=5f7675e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7675e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VContainer,VFlex,VForm,VLayout,VProgressCircular,VSpacer,VSwitch})
